import React, {Suspense, lazy} from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './redux/config/store';
import './index.css';
import Typography from '@mui/material/Typography';
const App = lazy(() => import('./App'));

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={(
      <div className='loading-screen'>
        <div>
          <div className="loadingio-spinner-ball-9s1dgspm2kp">
            <div className="ldio-j35m4wethue">
              <div></div>
            </div>
          </div>
          <Typography variant="body1" sx={{pl: '1rem'}} color='white'>
            Berpacu dalam melo<strong>dgy</strong>
          </Typography>
        </div>
      </div>
    )}>
      <App/>
    </Suspense>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
